import { useEffect } from 'react';

import PropTypes from 'prop-types';

const ScrollToElement = ({ elementId }) => {
    useEffect(() => {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [elementId]);

    return null;
};

ScrollToElement.propTypes = {
    elementId: PropTypes.string.isRequired,
};

export default ScrollToElement;
